"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight, Building2, Cog, HardHat } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const disciplines = [{
  id: "BUY-01",
  title: "Find a Home",
  description: "Browse our exclusive marketplace of owner-financed properties across the country. No traditional bank required.",
  icon: Building2,
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/luxury_home_exterior.png)]",
  link: "/FindHomePage"
}, {
  id: "SEL-02",
  title: "List Your Property",
  description: "Sell your home faster and earn more interest by offering private financing. We handle the marketing and buyer screening.",
  icon: Cog,
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/modern_property_listing.png)]",
  link: "/ListYourPropertyPage"
}, {
  id: "HOW-03",
  title: "How it Works",
  description: "Learn the gold standard of private real estate finance. Transparent processes for both buyers and sellers.",
  icon: HardHat,
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/financial_contract_blueprint.png)]",
  link: "/HowItWorksPage"
}];
export default function ChooseYourPath() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224944" id="choose-your-path" className="relative bg-background py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:32px_32px] opacity-10 pointer-events-none" />
      
      <div className="container mx-auto px-4 max-w-7xl relative z-10">
        <div ref={headerRef} className={`mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex items-center gap-4 mb-4">
            <div className="h-px w-12 bg-accent-foreground" />
            <span className="font-mono text-sm text-accent-foreground uppercase tracking-widest">
              Your Real Estate Journey
            </span>
          </div>
          <h2 className="font-default text-4xl md:text-5xl font-bold text-foreground tracking-tight">
            Choose Your Path
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
          {disciplines.map((item, i) => <div data-index={i} key={item.id} className="h-full">
              <Card className="group relative h-full rounded-md border border-border/50 bg-card/80 backdrop-blur-sm overflow-hidden transition-all duration-500 hover:border-accent-foreground/50 hover:shadow-xl hover:-translate-y-1">
                {}
                <div className={`absolute inset-0 bg-cover bg-center opacity-5 mix-blend-luminosity transition-all duration-700 group-hover:opacity-20 group-hover:scale-105 ${item.bgClass}`} />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-b from-transparent to-background/90 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                <CardContent className="relative z-10 p-8 flex flex-col h-full">
                  <div className="mb-auto">
                    <div className="flex justify-between items-start mb-8">
                      <item.icon className="size-10 text-secondary group-hover:text-accent-foreground transition-colors duration-300" strokeWidth={1.5} />
                      <span className="font-mono text-xs text-muted-foreground group-hover:text-accent-foreground/70 transition-colors duration-300">
                        {item.id}
                      </span>
                    </div>
                    
                    <h3 className="font-default text-2xl font-semibold text-foreground mb-4">
                      {item.title}
                    </h3>
                    <p className="font-default text-muted-foreground text-sm leading-relaxed">
                      {item.description}
                    </p>
                  </div>

                  {}
                  <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-all duration-500 ease-in-out">
                    <div className="overflow-hidden">
                      <div className="pt-8">
                        <Link to={item.link} className="inline-flex items-center gap-2 font-mono text-sm text-primary uppercase tracking-wider hover:text-accent-foreground transition-colors after:absolute after:inset-0">
                          Get Started
                          <ArrowRight className="size-4 transform group-hover:translate-x-1 transition-transform duration-300" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  
                  {}
                  <div className="absolute top-0 left-0 w-2 h-2 border-t border-l border-accent-foreground/0 group-hover:border-accent-foreground/50 transition-colors duration-300" />
                  <div className="absolute top-0 right-0 w-2 h-2 border-t border-r border-accent-foreground/0 group-hover:border-accent-foreground/50 transition-colors duration-300" />
                  <div className="absolute bottom-0 left-0 w-2 h-2 border-b border-l border-accent-foreground/0 group-hover:border-accent-foreground/50 transition-colors duration-300" />
                  <div className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-accent-foreground/0 group-hover:border-accent-foreground/50 transition-colors duration-300" />
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}